import NewsletterAdministrationLayout from 'components/newsletter-administration-layout/NewsletterAdministrationLayout';

import { INewsletterUnsubscribeConfirmationPage } from 'source/NFR.types';

const NewsletterUnsubscribeConfirmationPage: React.FC<INewsletterUnsubscribeConfirmationPage> = ({
  layout,
  title,
  text
}) => (
  <NewsletterAdministrationLayout {...layout} className="newsletter-unsubscribe-confirmation-page">
    {title && <h1>{title}</h1>}
    <p>{text}</p>
  </NewsletterAdministrationLayout>
);

NewsletterUnsubscribeConfirmationPage.displayName = 'NewsletterUnsubscribeConfirmationPage';

export default NewsletterUnsubscribeConfirmationPage;
